import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import { Link } from 'react-router-dom';
import { getVerifierWiseCurrentCallingStatus } from 'BaseComponentAPI/VerifierwiseCurrentCallingAPI';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';

const VerfierWiseCurrentCallingStatus = () => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";


    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('');

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const columns = useMemo(
        () => [
            {
                header: "Verifier Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Current Status",
                accessorKey: "currentLoginStatus",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Assignment Status",
                accessorKey: "assignmentStatus",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Board Name",
                accessorKey: "callBoardName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Process Cnt",
                accessorKey: "callProcessCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Connected Calls Cnt",
                accessorKey: "connectedCallsCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Converted Lead Cnt",
                accessorKey: "convertedLeadCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Time Duration",
                accessorKey: "callTimeDuration",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: true,
                cell: cellProps => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                                <Link
                                    to="/job-details"
                                    className="btn btn-sm btn-soft-primary"
                                    id={`viewtooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-eye-outline" />
                                </Link>
                            </li>
                            <UncontrolledTooltip
                                placement="top"
                                target={`viewtooltip-${cellProps.row.original.id}`}
                                transition={{ timeout: 0 }}
                            >
                                Show Details
                            </UncontrolledTooltip>
                        </ul>
                    )
                },
            },
        ],
        []
    )

    const [data, setData] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(8);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [8, 16, 24, 32, 40]

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(`${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                } else {
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup(error.message, 'error')
                console.error('Error fetching data:', error);
            }
        }
    };

    useEffect(() => {
        if (!canRead) {
            openPopup('Something went wrong!', 'error');
        }
        else {
            getData();
        }

    }, [authUser]);

    const getData = async () => {
        setLoaderOption(true);
        setData([]);
        setTotalPages('');
        setTotalItems('');
        setNextPage('');
        setPreviousPage('');
        setCurrentPage('');
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(`${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                } else {
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup(error.message, 'error')
                console.error('Error fetching data:', error);
            }
        }
    };

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0 && data.length !== 0) {
            try {
                const response = await axios.get(
                    `${getVerifierWiseCurrentCallingStatus}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    const rawData = response.data.data.items; // Original API response data

                    // Exclude "Action" column
                    const filteredColumns = columns.filter(col => col.header !== "Action");

                    // Define headers for Excel
                    const columnHeaders = filteredColumns.map(col => col.header);

                    // Map data to match the column headers order
                    const formattedData = rawData.map(item =>
                        columns.map(col => item[col.accessorKey] ?? "")
                    );

                    // Combine headers and data
                    const sheetData = [columnHeaders, ...formattedData];

                    // Create worksheet and workbook
                    const ws = XLSX.utils.aoa_to_sheet(sheetData);
                    const wb = XLSX.utils.book_new();

                    // Shortened sheet name (max 31 chars)
                    const sheetName = "Verifier Calling Status"; // 25 chars (within limit)
                    XLSX.utils.book_append_sheet(wb, ws, sheetName);

                    // Generate timestamp for filename
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
                    const formattedDate = currentDate.replace(',', '').replace(/\//g, '-').replace(/:/g, '-').split(' ')[0] + ' ' + currentDate.split(' ')[1];

                    // Set the file name dynamically
                    const fileName = `VerifierWiseStatus ${formattedDate}.xlsx`;

                    // Export the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                    console.error("API Response Error:", response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
                console.error("Error fetching data:", error);
            }
        }
    };



    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Cold Calls" breadcrumbItem="Upload Cold Calls" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption === true) {
            return (
                <>
                    <Loader />
                </>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Report" breadcrumbItem="Verifier Wise Current Calling Status" />
                            <Card>
                                <CardBody>
                                    {data && (
                                        <div className='mt-3'>
                                            <div className="d-flex align-items-center justify-content-end mb-2">
                                                <div className="flex-shrink-0">
                                                    <button
                                                        onClick={exportToExcel}  // Trigger the export function
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </button>
                                                </div>
                                            </div>
                                            <TableContainer
                                                columns={columns}
                                                data={data || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isCustomPageSize={true}
                                                tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                                getRowProps={row => ({
                                                    className: "",
                                                })}
                                                onPageChange={handlePageChange} // Pass page change handler
                                                onPageSizeChange={handlePageChange} // Pass page size change handler
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalPages={totalPages}
                                                totalItems={totalItems}
                                                tableNextPage={nextPage}
                                                tablePreviousPage={previousPage}
                                                tableCurrentPage={currentPage}
                                                customePageSize={customePageSize}
                                            />
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
};

export default VerfierWiseCurrentCallingStatus;
